import { render, staticRenderFns } from "./Favorability.vue?vue&type=template&id=c824496c&scoped=true"
import script from "./Favorability.vue?vue&type=script&lang=js"
export * from "./Favorability.vue?vue&type=script&lang=js"
import style0 from "./Favorability.vue?vue&type=style&index=0&id=c824496c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c824496c",
  null
  
)

export default component.exports